import { render, staticRenderFns } from "./MainEnd.vue?vue&type=template&id=73ecab47&"
import script from "./MainEnd.vue?vue&type=script&lang=js&"
export * from "./MainEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports